// *** Email regular expression ***
const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

// *** Domain regular expression ***
const domainRegex = /(?:www\.)?[^0-9]\S*\.[^0-9]\S*/;

// *** Export regex ***
export { emailRegex, domainRegex };
